import { ResponsiveFloraTypography } from 'components';
import { Skeleton } from 'components/Skeleton';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

export const Title = () => {
  const { data: incentiveCampaign, isLoading } = useLoyaltyIncentiveCampaign();

  if (isLoading)
    return <Skeleton data-testid='results-skeleton-heading' height='$18' width='50%' />;
  const title = incentiveCampaign?.title ?? 'Campanha de Incentivos';

  return (
    <ResponsiveFloraTypography fontSize='title' fontWeight='bold' as='h1'>
      {title}
    </ResponsiveFloraTypography>
  );
};
